import { useContext, useEffect } from "react";
import Footer from "./components/Footer";
// import LiveStat from "./components/LiveStat";
import NavbarTop from "./components/Navbar";

import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { isInfiniti } from "./Web3/Function";
import { AppContext } from "./AppContext";

  import {
  get_Token_Balance_Other,
  reservedEuroinUSDT,
  reserveTokenBalanceforMultiSignWallet,
  reserveTokenBalanceforMultiSignWalletInDoller,
  Totak_Supply,
} from "./Web3/Methods";

import "./Global.css";
// import Swap from "./components/Swap";
import { defaultchainid, defaultCirculationSupply, defaultMaalReserveUSDT, idTorpc, multisigwallet, tokenAddress } from "./Web3/Constents";
import Mint from "./components/Mint";
import { coinGeckotokensPrice, MaalPriceInDollar } from "./Web3/Axioscalls";
import Reserves from "./components/TotalAssets";
import axios from "axios";
import { euroReserved } from "./Web3/Constents";
import Login from "./components/Login";
import PinVerification from "./components/PinVerification";
import { ProtectedRoute } from "./components/ProtectedRoute";

function App() {
  const {
    user,
    update,
    euroreserved,
    selectedToken,
    setReservedinDoller,
    setReservedassets,
    setEuroReserved,
    setEuroReservedUSDT,
    setLockedERUOResver,
    setMaalPrice,
    setUser,
    setTotalS,
    setEUSD,
    setTotalSBsc,
    setTotalBurn,
    setMaalReserveUSDT,
    setTotalBurnETH,
    setTotalMintETH,
    setTotalMint,
    setDisabledAction,
    setMinBurnAllowd,
    setRusdbalance,
    setNinepercentReserve,
    setBtcDollarValue,
    setBtcValue,
    setTotalSEth,
    setBurnAllowedStatus
  } = useContext(AppContext);

  useEffect(() => {
    try {
      const init = async () => {
        APIs();
      };
      init();
    } catch (error) {
      console.error(error);
    }
  }, [user, update, euroreserved, selectedToken]);


   const fetchBTCValue = async () => {
        try {
          const formData = new FormData();
          formData.append("type", "email");
          formData.append("item", "chief@goldchainex.com");
          formData.append("channel", "gcs");
          let finalvalue = 0
  
          const response = await fetch("https://sapi4.gcex.lt/v1/balance/query", {
            method: "POST",
            headers: {
              Authorization: "97da04fa2e2c499f8452c1cac1562094",
            },
            body: formData,
          });
  
          const data = await response.json();
          
          if (data && data.data) {
            const btcData = data.data.find(asset => asset.symbol === "BTC");
            if (btcData) {
              const totalBTC = (btcData.available || 0) + (btcData.freeze || 0);
              const btcPrice = await coinGeckotokensPrice('bitcoin');
           
              setBtcValue(totalBTC);
              setBtcDollarValue(totalBTC * btcPrice);
              finalvalue =  (totalBTC * btcPrice) || 0
            }
          }
        return finalvalue
        } catch (error) {
          console.error("Error fetching BTC value:", error);
        }
      };

    const ERUOData =async()=>{
     const data = await  axios.get(euroReserved).then((res)=>{
        // setEuroReserved(Number(res.data?.['euro-cash-reserve']))
        setEuroReserved(Number(0))
        setLockedERUOResver("0000-00-00 00:00:00")
        // setLockedERUOResver(res.data?.['locked-till'])
        // return Number(res.data?.['euro-cash-reserve']) ? Number(res.data?.['euro-cash-reserve']) : 0
        return 0;
      }).catch((err)=>{
        console.log("Error: ", err)
        return 0
      })
      return data
    }



    const _burnAllowedFromapi =async()=>{
      axios.get("https://por-api.infinnity.capital/don-1/mint-icusd").then((res)=>{
        setBurnAllowedStatus(res.data?.status)
       }).catch((err)=>{
         console.log("Error: ", err)
         setBurnAllowedStatus(false)
       })
     }


  const APIs = async () => {
    // Get total supply based on selected token
    let totalsupply;
    let euroPriceInUSD = 1; // Default for ICUSD
    
    if (selectedToken === "ICEUR") {
      totalsupply = await Totak_Supply("ICEUR");
      // Fetch ICEUR price from CoinGecko (euro-coin)
      try {
        euroPriceInUSD = await coinGeckotokensPrice("euro-coin");
        setEUSD(euroPriceInUSD || 1.05); // Fallback to ~1.05 if fetch fails
      } catch (error) {
        console.error("Error fetching euro-coin price:", error);
        setEUSD(1.05);
      }
    } else {
      // ICUSD selected
      totalsupply = await Totak_Supply("ICUSD");
      setEUSD(1);
    }
    
    setTotalSBsc(totalsupply);
    setTotalS(totalsupply);
    
    // Get token balance for selected token
    const tokenbal = await get_Token_Balance_Other(tokenAddress[selectedToken], user, idTorpc[defaultchainid])
    setRusdbalance(tokenbal)

    const reservedinDoller = await reserveTokenBalanceforMultiSignWalletInDoller(multisigwallet);
    setReservedinDoller(reservedinDoller);

    const assetsreserved = await reserveTokenBalanceforMultiSignWallet(multisigwallet);
    setReservedassets(assetsreserved);

    setMaalReserveUSDT(assetsreserved.find(i=> i.symbol === "MAAL")?.value || 80000000)

    setDisabledAction(totalsupply >= defaultCirculationSupply && assetsreserved.find(i=> i.symbol === "MAAL")?.value < defaultMaalReserveUSDT)
    
    const maalpriceDoller = await MaalPriceInDollar();
    setMaalPrice(maalpriceDoller);

    // Note: totalBurned() and totalMinted() don't exist in new ABI
    // You'll need to track these via events or remove them
    // setTotalBurn(0)
    // setTotalMint(0)

    const _euro_reserve  = await ERUOData()

    const euroreservedusdt= await reservedEuroinUSDT(_euro_reserve);
    setEuroReservedUSDT(euroreservedusdt);

    _burnAllowedFromapi();
    const btcDollarValue = await fetchBTCValue();
   
    setBtcDollarValue(btcDollarValue)
    
    setNinepercentReserve((reservedinDoller + euroreservedusdt + btcDollarValue) * 0.9)
 
    setMinBurnAllowd(((reservedinDoller + euroreservedusdt + btcDollarValue) * 0.9) - totalsupply)
  };



  try {
    window.ethereum.on("accountsChanged", function (accounts) {
      setUser(accounts[0]);
    });
  } catch (error) {}

  return (
    <div className="App">
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/verify-pin" element={<PinVerification />} />
          
          {/* Protected Routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <>
                <NavbarTop />
                <Mint />
                <Footer />
              </>
            </ProtectedRoute>
          } />
          
          <Route path="/reserves" element={
            <ProtectedRoute>
              <>
                <NavbarTop />
                <Reserves />
                <Footer />
              </>
            </ProtectedRoute>
          } />
          
          {/* Redirect any unknown routes to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;


